export const STATUS = {
  AGUARDANDO_APROVACAO: -1,
  INATIVO: 0,
  ATIVO: 1,
}

export const DEFAULT_STATUS_FILTER = STATUS.ATIVO;

export const STATUS_FILTERS = [
  { label: "Ativos", value: STATUS.ATIVO },
  { label: "Bloqueados", value: STATUS.INATIVO },
  { label: "Todas", value: null },
];
